<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת זמן תעודה</h1>
      </template>
      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="id">שם מזהה</label>

          <InputText   type="text" v-model="newItem.id" autofocus />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="displayName">שם</label>
          <InputText  type="text" v-model="newItem.displayName" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label for="startDate">תאריך התחלה</label>
          <calendar type="text" v-model="newItem.startDate" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label for="endDate">תאריך סוף</label>
          <calendar type="text" v-model="newItem.endDate" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label for="endDate">למנהל בלבד</label>
          <checkbox  :binary="true" v-model="newItem.forAdminOnly" />
        </div>
          <div class="p-field p-col-12 p-md-6">
              <label for="endDate">להצגה כתעודה ישנה להשוואה</label>
              <checkbox  :binary="true" v-model="newItem.forOldShow" />
          </div>
      </div>


    <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../../../service/Service";
export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      newItem: null,
    };
  },

  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: null,
          displayName: null,
          startDate: null,
          endDate: null,
          forAdminOnly: false,
          forOldShow: false,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }

      if (validate === true) {
          this.newItem.startDate = this.newItem.startDate.getTime()
          this.newItem.endDate = this.newItem.endDate.getTime()
        await this.service
          .addReportDates(this.newItem)
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `זמן תעודה התווסף בהצלחה`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו לעדכן במערכת`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>